import {
   QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { AgentsApiService } from 'features/agent/api/agents-api.service';
import type { AgentLogResponse } from 'features/agent/types/agentlog';
import type { EventsParams } from 'features/cms';

import { AgentsQueryKeys } from './query-keys';

const { getAgentList } = AgentsApiService();

/* ---------------- QUERY FACTORY ---------------- */
const getAgentListQuery = (
  params: EventsParams,
  options?: UseQueryOptions<AgentLogResponse>
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<AgentLogResponse>;
  options?: UseQueryOptions<AgentLogResponse>;
} => ({
  queryKey: AgentsQueryKeys.list(params),
  queryFn: ({ signal }) => getAgentList(params, { config: { signal } }),
  ...options,
});

/* ---------------- HOOK ---------------- */
export const useGetAgentList = (
  params: EventsParams & {
    page?: number;
    size?: number;
    name?: string;
    userId?: string;
    actionType?: string;
  },
  options?: UseQueryOptions<AgentLogResponse>
) => {
  const { message } = App.useApp();

  return useQuery<AgentLogResponse, Error>(
    getAgentListQuery(params, {
      onError: (error: unknown) => {
        message.error(handleError(error));
      },
      ...options,
    })
  );
};
